import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import "./Doughnut.css";
import { chartColors } from "../../reports/colors";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { t } from "i18next";

const DoughnutChart = (props) => {

  const MAX_ENTRIES = 15; // limit the number of slices
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);

  useEffect(() => {
    prepareChartData();
  }, [props.data, props.label]);

  const prepareChartData = () => {
    const numericData = props.data.map((d) => parseFloat(d) || 0);
    const total = props.totalValuePercentage || numericData.reduce((a, b) => a + b, 0);

    // Pair labels and data together
    const labeledData = props.label.map((label, idx) => ({
      label,
      value: numericData[idx],
      percent: total > 0 ? (numericData[idx] / total) * 100 : 0,
    }));

    // Sort descending by value
    const sorted = [...labeledData].sort((a, b) => b.value - a.value);

    // Split top and remaining
    const topData = sorted.slice(0, MAX_ENTRIES);
    const remainingData = sorted.slice(MAX_ENTRIES);

    // Sum "Others"
    const othersValue = remainingData.reduce((sum, d) => sum + d.value, 0);

    // If there are remaining values, push an "Others" slice
    if (othersValue > 0) {
      topData.push({
        label: t("Others"),
        value: othersValue,
        percent: total > 0 ? (othersValue / total) * 100 : 0,
      });
    }

    // Prepare rows for Google Chart
    const rows = [["Label", "Value"]];
    topData.forEach((item) => {
      const labelWithPercent = `${item.label} (${item.percent.toFixed(2)}%)`;
      rows.push([labelWithPercent, item.value]);
    });

    // Assign consistent colors
    const colors = topData.map((_, i) => chartColors[i % chartColors.length]);
    setChartData(rows);
    setColorData(colors);

    // Update parent component state if setters are provided
    if (props.setChartData && typeof props.setChartData === 'function') {
      props.setChartData(rows);
    }
    if (props.setColorData && typeof props.setColorData === 'function') {
      props.setColorData(colors);
    }
  };

  const handleClick = (chartWrapper) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();

    if (selection.length > 0) {
      const selectedItem = selection[0];
      const selectedIndex = selectedItem.row;
      const selectedLabel = chartData[selectedIndex + 1][0];
      props.typeGetter(selectedLabel.replace(/\s*\([^)]*\)\s*/g, ""), props.section);
    }
  };

  return (
    <>
      <div
        id={props?.id ? props?.id : "pdf-content"}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {chartData.length > 1 && (
          <>
            {/* ✅ Custom Legend */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                marginBottom: "10px",
               
              }}
            >
              {chartData.slice(1).map((row, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "4px 8px",
                    fontSize: "13px",
                    fontWeight: "500",
                  }}
                >
                  <div
                    style={{
                      width: "14px",
                      height: "14px",
                      backgroundColor: colorData[index] || chartColors[index % chartColors.length] || "#ccc",
                      marginRight: "6px",
                      borderRadius: "3px",
                    }}
                  ></div>
                  {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
                </div>
              ))}
            </div>

            {/* ✅ Centered Doughnut Chart */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              
              }}
            >
              <Chart
                chartType="PieChart"
                data={chartData}
                width={window.innerWidth > 500 ? "800px" : "320px"}
                height={window.innerWidth > 500 ? "500px" : "300px"}
                options={{...props.options, colors: colorData}}
                chartEvents={[
                  {
                    eventName: "select",
                    callback: ({ chartWrapper }) => handleClick(chartWrapper),
                  },
                ]}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default DoughnutChart;
